module.exports = __webpack_public_path__ + "img/1440.a620fe19.jpg";